import React from "react";
//#region types
import { SalaryDraftFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { TableEnums } from "models/enums";
import { ReportConstants } from "utils/constants";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { DashboardButtonGroup, FilterButton, PageLayouts, ReloadEvent, TableContextProvider } from "components/common";
import { Grid } from "@mui/material";
import { EditSalaryButton, SalarySpecificationsListView } from "components/salary";
import useSalaryDraftReportFilterDefinition from "./forms/useSalaryReportFilterDefinition";
import SalaryDraftListView from "./salaryListView";
import { useEmployeeActions, useEmployeeHelpers } from "components/employee";
import { useSalaryService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SalaryDraftReport: React.FC = (props) => {
  const salaryService = useSalaryService();
  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useSalaryDraftReportFilterDefinition();

  const { employeeSettingsMoreAction, addEmployeeMoreAction } = useEmployeeActions();
  const { canBulkEditSalaries } = useEmployeeHelpers();

  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.SalaryDraft}
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout<SalaryDraftFormTypes.SalaryFilter>
          entityKey={0}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Company.Salaries)}
          topRightButtons={
            <DashboardButtonGroup
              buttons={(canBulkEditSalaries
                ? [<EditSalaryButton />, ACTION_SEPARATOR as typeof ACTION_SEPARATOR]
                : []
              ).concat([<FilterButton />])}
              moreActions={[addEmployeeMoreAction, employeeSettingsMoreAction]}
            />
          }
          filterFields={reportFilterDefinition}
          filterQueryStateHandler={filterQueryStateHandler}
          filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.SalaryDraft}
          reportToAPIFilterFormatter={salaryService.salaryDraftReportToAPIFilter}
          apiToReportFilterFormatter={apiToReportFilterFormatter}
        >
          <Grid container item>
            <TableContextProvider tableKey={TableEnums.TableType.SalaryDraftList}>
              <SalaryDraftListView reloadKey={reloadKey} reloadSalaryDrafts={reload} />
            </TableContextProvider>
          </Grid>
          <Grid container item>
            <SalarySpecificationsListView useExtendedFilter={false} />
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default SalaryDraftReport;
